/**
 * This class provides a ScratchLinkSocket implementation using WebSockets,
 * attempting to connect with the locally installed Scratch-Link.
 *
 * To connect with ScratchLink without WebSockets, you must implement all of the
 * public methods in this class.
 * - open()
 * - close()
 * - setOn[Open|Close|Error]
 * - setHandleMessage
 * - sendMessage(msgObj)
 * - isOpen()
 */
class ScratchLinkWebSocket {
    constructor(type) {
        this._type = type;
        this._onOpen = null;
        this._onClose = null;
        this._onError = null;
        this._handleMessage = null;

        this._ws = null;
    }

    open() {
        // Dynamically choose the correct protocol: 'wss:' if HTTPS, otherwise 'ws:'
        /*const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
        const urls = window.location.protocol === 'https:' ? 'stemblock.in/stemblock' : '127.0.0.1:20111';*/
        const protocol = 'ws:';
        const urls = '127.0.0.1:20111';
        let url;
        switch (this._type) {
            case 'BLE':
                url = `${protocol}//${urls}/stemblock/ble`;
                break;
            case 'BT':
                url = `${protocol}//${urls}/stemblock/bt`;
                break;
            case 'SERIALPORT':
                url = `${protocol}//${urls}/stemblock/serialport`;
                break;
            default:
                throw new Error(`Unknown StemblockLink socket Type: ${this._type}`);
        }
       /* console.log(url,'url',protocol);*/
        this._ws = new WebSocket(url);

        // Ensure handlers are set before opening the socket.
        if (this._onOpen && this._onClose && this._onError && this._handleMessage) {
            this._ws.onopen = this._onOpen;
            this._ws.onclose = this._onClose;
            this._ws.onerror = this._onError;
        } else {
            throw new Error('Must set open, close, message and error handlers before calling open on the socket');
        }

        this._ws.onmessage = this._onMessage.bind(this);
    }

    close() {
        //if (this._ws) {
            this._ws.close();
            this._ws = null;
        //}
    }

    sendMessage(message) {
        const messageText = JSON.stringify(message);
        this._ws.send(messageText);
    }

    setOnOpen(fn) {
        this._onOpen = fn;
    }

    setOnClose(fn) {
        this._onClose = fn;
    }

    setOnError(fn) {
        this._onError = fn;
    }

    setHandleMessage(fn) {
        this._handleMessage = fn;
    }

    isOpen () {
        return this._ws && this._ws.readyState === this._ws.OPEN;
    }

    _onMessage(e) {
        const json = JSON.parse(e.data);
        this._handleMessage(json);
    }
}

module.exports = ScratchLinkWebSocket;
